import { Fragment, useEffect, useState, createContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import { meta as chartsMeta } from 'views/charts/Landing';
import { meta as correlationMeta } from 'views/correlation/Landing';
import { meta as insightToolboxMeta } from 'views/insights-toolbox/Landing';
import { meta as performanceEngineMeta } from 'views/performance-engine/Landing';
import { meta as riskLabMeta } from 'views/risk-lab/Landing';
import { meta as userGuideMeta } from 'views/user-guide/Landing';

function landingMetaToMenus(meta) {
  return {
    path: meta.path,
    items: meta.items.map((item) => {
      return {
        label: item.title,
        navigate: { pathname: `${meta.path}${item.path}` },
        permission: item.permission,
      };
    }),
  };
}

const defaultMenus = [
  {
    value: 'Investment Analysis',
    label: 'Investment Analysis',
    navigate: { pathname: '/ia', search: 'minass=true' },
    permission: 'ia',
  },
  {
    value: 'Investment Comparison',
    label: 'Investment Comparison',
    navigate: { pathname: '/ic', search: 'multi=true&minass=true' },
    permission: 'ic',
  },
  {
    value: 'Portfolio Engineer',
    label: 'Portfolio Engineer',
    permission: 'pa',
    subs: [
      {
        value: 'Build and Analyze',
        label: 'Build and Analyze',
        navigate: { pathname: '/pa/build', search: 'single=true' },
        permission: 'pa-build',
      },
      {
        value: 'Compare',
        label: 'Compare',
        navigate: { pathname: '/pa/compare' },
        permission: 'pa-compare',
      },
      {
        value: 'Portfolio Optimization',
        label: 'Portfolio Optimization',
        navigate: { pathname: '/pa/portfolio-optimization' },
        permission: 'pa-portfolio-optimization',
      },
    ],
  },
  // {
  //   value: 'Advanced Analytics',
  //   label: 'Advanced Analytics',
  //   navigate: { pathname: '/analyzers/asset-discovery-aa' },
  //   permission: 'aa',
  // },
];

const landingMenus = [
  landingMetaToMenus(chartsMeta),
  landingMetaToMenus(correlationMeta),
  landingMetaToMenus(insightToolboxMeta),
  landingMetaToMenus(performanceEngineMeta),
  landingMetaToMenus(riskLabMeta),
  landingMetaToMenus(userGuideMeta),
];

function AnalyzerMenus({ session }) {
  const location = useLocation();
  const navigate = useNavigate();

  const permissions = session?.permissions || {};
  if (!permissions['member']) return null;

  let allowedMenus = [];
  if (location.pathname === '/quickview') {
    allowedMenus = [];
  } else {
    const landingMenu = landingMenus.find(
      (menu) => location.pathname === menu.path || location.pathname.startsWith(`${menu.path}/`),
    );
    if (landingMenu) {
      allowedMenus = landingMenu.items.filter((item) => permissions[item.permission]);
    } else {
      allowedMenus = defaultMenus.filter((menu) => permissions[menu.permission]);
    }
  }

  return (
    <>
      {allowedMenus.map((menu) => {
        return menu.navigate ? (
          <button
            className="tw-text-[#191870] tw-border-0 tw-bg-transparent tw-font-bold tw-text-sm ml-2"
            type="button"
            onClick={() => {
              navigate(menu.navigate, { replace: false });
            }}
          >
            {menu.label}
          </button>
        ) : (
          <Menu as="span" className="tw-relative">
            <Menu.Button
              className="tw-text-[#191870] tw-border-0 tw-bg-transparent tw-font-bold tw-text-sm ml-2"
              type="button"
            >
              {menu.label}
            </Menu.Button>
            <Menu.Items className="tw-absolute tw-border-gray-300 tw-border-solid tw-border tw-right-0 tw-z-10 tw-mt-2 tw-w-48 tw-origin-top-right tw-rounded-md tw-bg-white tw-py-1 tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5">
              {menu.subs
                .filter((sub) => {
                  if (!sub.permission) return true;
                  return permissions[sub.permission];
                })
                .map((sub) => {
                  return (
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          type="button"
                          className="tw-border-0 tw-bg-transparent tw-text-sm ml-2 tw-block tw-p-2 hover:tw-underline"
                          onClick={() => {
                            navigate(sub.navigate, { replace: false });
                          }}
                        >
                          {sub.label}
                        </button>
                      )}
                    </Menu.Item>
                  );
                })}
            </Menu.Items>
          </Menu>
        );
      })}
    </>
  );
}

export default AnalyzerMenus;
